import CustomFilterSelect from "./CustomFilterSelect";

const FilterBorrowerAgreement = (props: any) => {
  const FilterData = [
    { id: "Pending Signature", name: "Pending Signature" },
    // { id: "Pending Signature Expired", name: "Pending Signature Expired" },//removed it , add new column Expired
    // { id: "Signature Failed", name: "Signature Failed" },
    { id: "Signature Completed", name: "Signature Completed" },
    { id: "Pending ACH", name: "Pending ACH" },
    // { id: "ACH Completed", name: "ACH Completed" },
    { id: "Purchase Pending", name: "Purchase Pending" },
    { id: "Purchase Completed", name: "Purchase Completed" },
  ];
  const authrole = localStorage?.getItem("authrole")?.toString();
  return (
    <CustomFilterSelect
      source="borrowerAgreement"
      label="Borrower Agreement"
      choices={FilterData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterBorrowerAgreement;
